module.exports = __webpack_public_path__ + "img/header-bg-zh.a7bc8f48.png";